import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Avatar from '../Avatar';
import StarRating from '../StarRating/StarRating';

import messages from '../../locale/messages';
import { formatDate } from '../../helpers/momentFormatter';

import s from './ViewProfile.css';

class ResponseItem extends React.Component {

    static propTypes = {
        formatMessage: PropTypes.any,
        data: PropTypes.shape({
            authorData: PropTypes.shape({
                picture: PropTypes.string,
                firstName: PropTypes.string.isRequired,
                lastName: PropTypes.string.isRequired,
                profileId: PropTypes.number.isRequired,
            }),
        }),
    };

    render() {
        const { data: { authorData: { firstName, profileId, picture, isMigrated } } } = this.props;
        const { data: { reviewContent, rating, createdAt }, userProfileId } = this.props;
        const { formatMessage } = this.props.intl;
        let date = formatDate({ date: createdAt, format: 'DD/MM/YYYY' });

        return (
            <div>
                <div className={cx(s.reviewBody, s.pullLeft, 'floatRight')}>
                    <Avatar
                        source={picture}
                        height={34}
                        width={34}
                        title={firstName}
                        className={s.profileAvatar}
                        withLink
                        linkClassName={cx(s.avatarDisplay, s.profileAvatarLink)}
                        profileId={profileId}
                        isFromMigration={isMigrated}
                    />
                </div>
                <div className={s.reviewBody}>
                    <div className={s.responseTitle}>{userProfileId == profileId ? formatMessage(messages.your) : firstName} <FormattedMessage {...messages.response} /></div>
                    {
                        reviewContent &&
                        <div className={s.reviewFlex}>
                            <StarRating className='smallStarRatingAdjust' />
                            <div>{rating}</div>
                            <div className={cx(s.dateReviewCss, 'dateReviewCssRTL')}>{date}</div>
                        </div>
                    }
                    <p className={s.wordbreak}>
                        {
                            reviewContent
                        }
                    </p>
                </div>
            </div>
        );
    }
}

export default injectIntl(withStyles(s)(ResponseItem));